import { Config } from '@/config/config'
import { useAppStore } from '../../store'
import Cookies from 'js-cookie'

const existingEventsStore: Record<string, EventSource> = {}

export const registerEvents = (id: string): EventSource | null => {
  if (existingEventsStore?.[id]) {
    return existingEventsStore[id]
  }

  const { updateProcess } = useAppStore.getState()

  let eventRecieved = false
  /* let liveProc: EventSource | null = null

  const registerLive = () => {
    const {
      auth: { user },
    } = useAppStore.getState()

    if (!user?.accessToken) {
      return null
    }

    const liveEvent = new EventSource(
      `${Config.SERVER}/app/live?id=${id}&token=${user?.accessToken || ''}`,
    )
    liveEvent.onmessage = ({ data }: { data: string }) => {
      const { processes } = useAppStore.getState()
      const { url } = JSON.parse(data)
      const process = processes?.[id]
      eventRecieved = true

      if (url && process) {
        updateProcess(id, {
          pageCount: (process.pageCount ?? 0) + 1,
        })
      }
    }
    return liveEvent
  }

  liveProc = registerLive()
  if (liveProc) {
    liveProc.onerror = () => {
      liveProc?.close()
      liveProc = registerLive()
    }
  } */

  let finishProc: EventSource | null = null
  const registerFinish = () => {
    const accessToken = Cookies.get('access_token')

    const finishEvent = new EventSource(
      `${Config.SERVER}/app/finished?id=${id}&token=${accessToken || ''}`,
    )
    finishEvent.onmessage = ({ data }: { data: string }) => {
      const { id: processId, pages, pageCount } = JSON.parse(data)
      eventRecieved = true
      if (processId && pages) {
        const allPages = pages ?? []
        if (allPages.length > 100) {
          allPages.splice(0, 100)
        }

        updateProcess(processId, {
          pages: allPages,
          pageCount: pageCount ?? 0,
          isFinished: true,
        })

        // finishEvent.close()
      }
    }

    return finishEvent
  }

  finishProc = registerFinish()
  finishProc.onerror = function () {
    finishProc?.close()
    finishProc = registerFinish()
  }

  const iv = setTimeout(
    () => {
      if (!eventRecieved) {
        useAppStore.getState().updateProcess(id, {
          isFinished: true,
        })
      } else {
        clearTimeout(iv)
      }
    },
    3 * 60 * 1000,
  ) // If no data within 3 minutes

  existingEventsStore[id] = finishProc

  return existingEventsStore[id]
}
